import { useMemo } from 'react';

import { isObjectEmpty } from '@/utils/comparisonUtils';
import { isEmptyContent } from '@/utils/innerHtmlUtils';
import { getAttributeValue, getAttributeId } from '@/utils/productUtils';
import { ATTRIBUTES } from '@/constants/product';

const GOOGLE_OFF = '<!--googleoff: all-->';
const DOUBLE_LINE_BREAK = '<br /><br />';

function useProductDetails(product, ratingOrder) {
  const buildInfo = (product, ratingOrder) => {
    const attributes = product.attributes || {};
    const desc = product.longdesc || '';
    const info = {};

    if (isObjectEmpty(product)) {
      return info;
    }

    info.attributes = Object.values(attributes).sort((a, b) => a.sequence - b.sequence);

    const index = desc?.indexOf(GOOGLE_OFF);
    if (index > 0) {
      info.longdesc = desc.slice(0, index);
      info.wineadvocate = desc.slice(index);
    } else if (index === 0) {
      info.wineadvocate = desc;
    } else {
      info.longdesc = desc;
    }

    if (info.longdesc?.endsWith(DOUBLE_LINE_BREAK)) {
      info.longdesc = info.longdesc.substring(0, info.longdesc.length - DOUBLE_LINE_BREAK.length);
    }

    if (isEmptyContent(info.longdesc)) {
      info.longdesc = '';
    }

    info.firstRating = attributes[ratingOrder?.[0].name] || {};
    info.firstRatingMax = ratingOrder?.[0].ratingMax;

    info.secondRating = attributes[ratingOrder?.[1].name] || {};
    info.secondRatingMax = ratingOrder?.[1].ratingMax;

    info.region = getAttributeValue(product, ATTRIBUTES.REGION);
    info.appellation = getAttributeValue(product, ATTRIBUTES.APPELLATION);
    info.productId = getAttributeId(product, ATTRIBUTES.TYPE_PRODUIT);
    info.parkerTastingNote = product.parkerTastingNote;

    info.showDescription = !!(info.region || info.longdesc || info.wineadvocate || info.isFirstRating || info.isSecondRating);

    return info;
  };

  return useMemo(() => buildInfo(product, ratingOrder), [product, ratingOrder]);
}

export default useProductDetails;
